module.exports = __webpack_public_path__ + "static/media/tiktok-original.9cb11592.svg";